import Duration from "../core/Duration";
import DateTime from "../core/DateTime";

export default class NotificationUtuils {
  public constructor() {}
  public static getLastNotificationUsed(last: DateTime): string {
    let currentDate: DateTime = DateTime.now();

    let lastUsedDate: DateTime = last.toLocal();

    let diff: Duration = currentDate.difference(lastUsedDate);

    let message: string = "";

    if (diff.inDays > 0) {
      if (diff.inDays.toInt() === 1) {
        message = "Yesterday";
      } else {
        message = diff.inDays.toString() + " days ago";
      }
    } else if (diff.inHours > 0) {
      if (diff.inHours === 1) {
        message = "1 hour ago";
      } else {
        message = diff.inHours.toString() + " hours ago";
      }
    } else if (diff.inMinutes > 0) {
      if (diff.inMinutes === 1) {
        message = "1 minute ago";
      } else {
        message = diff.inMinutes.toString() + " minutes ago";
      }
    } else {
      message = diff.inSeconds.toString() + " seconds ago";
    }

    return message;
  }
}
